import React, { ReactNode } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  position:absolute;
  bottom:0;
  display: flex;
  height: 60px;
  border-radius: 0px 24px 0px 0px;
  background-color: transparent;
  padding: 10px 12.5px;

  & > {
    div:first-child{
      margin-right: 8px;
    }
  }
  @media only screen and (min-width: 1280px){
    width: calc(100% - 415px);
    background-color: transparent;
    padding-left: 20%;
    padding-right: 20%;
    max-width: 1097px;
  }
  @media only screen and (max-width: 1280px){
    width: 100%;
  }
`;

interface Props {
  children: ReactNode,
}

const ContainerAtom = ({ children }: Props) => (
  <Container>
    {children}
  </Container>
);

export default ContainerAtom;
